var React = require('react');

function IconHtmlUnderline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M5.40636 9.09938c-2.20987 0-3.77525-1.19918-3.77525-3.54826V1.5H.9491c-.21304 0-.38572-.16788-.38572-.375v-.75C.56338.16788.73606 0 .9491 0h3.31208c.21303 0 .38571.16788.38571.375v.75c0 .20712-.17268.375-.38571.375h-.6946v4.05112c0 1.25858.68257 1.86197 1.83978 1.86197 1.13222 0 1.82723-.5961 1.82723-1.87418V1.5h-.68202c-.21303 0-.38571-.16788-.38571-.375v-.75c0-.20712.17268-.375.38571-.375h3.2995c.21304 0 .38571.16788.38571.375v.75c0 .20712-.17267.375-.38571.375h-.68201v4.05112c0 2.32981-1.5641 3.54826-3.7627 3.54826zM.38571 10.5H10.4143c.21303 0 .38571.16788.38571.375v.75c0 .20712-.17268.375-.38571.375H.3857C.17268 12 0 11.83212 0 11.625v-.75c0-.20712.17268-.375.38571-.375z"}));
}

IconHtmlUnderline.defaultProps = {"viewBox":"0 0 11 12"};

module.exports = IconHtmlUnderline;

IconHtmlUnderline.default = IconHtmlUnderline;
